import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import { unitTranslation } from "@/common/constants/unitStrategies.contants";
import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

const unitForConsumptionOptions = strategyToOptions(unitTranslation);

const DashboardFilterEquipmentCategoryUnitForConsumptionSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  return (
    <SheetFiltersItem
      label={dashboardFilters[DashboardFilters.EquipmentCategoryUnitForConsumption]}
      value={filters[DashboardFilters.EquipmentCategoryUnitForConsumption]?.value || ''}
      options={[{ label: 'Todas', value: '' }, ...unitForConsumptionOptions]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.EquipmentCategoryUnitForConsumption]: value }))}
    />
  );
}

export default DashboardFilterEquipmentCategoryUnitForConsumptionSheet;
